import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output
} from '@angular/core';
import {
  AvailabilityOverviewKpis,
  AvailabilityTeamKpi
} from '../../domain/collector-availability-overview.model';

@Component({
  selector: 'app-availability-kpis',
  templateUrl: './availability-kpis.component.html',
  styleUrls: ['./availability-kpis.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AvailabilityKpisComponent {
  @Input() kpis: AvailabilityOverviewKpis | null = null;
  @Input() selectedTeam = '';
  @Output() teamSelected = new EventEmitter<string>();

  selectTeam(team: string): void {
    this.teamSelected.emit(team);
  }

  trackByTeam(_: number, item: AvailabilityTeamKpi): string {
    return item.team;
  }
}
